var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleQuestionSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "circle-question-solid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle-question-solid",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#circle-question-solid)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "circle-question-solid-2",
    "data-name": "circle-question-solid",
    d: "M40,80A40,40,0,1,0,0,40,40,40,0,0,0,40,80ZM26.531,25.828A8.765,8.765,0,0,1,34.781,20h9.109A9.866,9.866,0,0,1,48.8,38.422L43.75,41.313a3.75,3.75,0,0,1-7.5-.062V39.141a3.742,3.742,0,0,1,1.891-3.25l6.922-3.969a2.359,2.359,0,0,0-1.172-4.406H34.781a1.23,1.23,0,0,0-1.172.828l-.062.187a3.746,3.746,0,1,1-7.062-2.5l.063-.187ZM35,55a5,5,0,1,1,5,5A5,5,0,0,1,35,55Z",
    transform: "translate(9 6)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionSolid);
export default __webpack_public_path__ + "static/media/circle-question-solid.f2a997ce0fcc21330cb21ec820f798c4.svg";
export { ForwardRef as ReactComponent };